import React from "react";
import "./ExperienceCard.scss";

export default function ExperienceCard({cardInfo, isDark}) {
  const GetDescBullets = ({descBullets}) => {
    return descBullets
      ? descBullets.map((item, i) => (
          <li key={i} className="experience-text-desc-bullet">
            {item}
          </li>
        ))
      : null;
  };

  return (
    <div className={isDark ? "experience-card-dark" : "experience-card"}>
      <div className="experience-card-header">
        <div className="experience-card-logo-div">
          <img
            className="experience-card-logo"
            src={cardInfo.companylogo}
            alt={cardInfo.company}
          />
        </div>
        <div className="experience-card-title-div">
          <h3 className="experience-card-role">{cardInfo.role}</h3>
          <h5 className="experience-card-company">{cardInfo.company}</h5>
          <h5 className="experience-card-date">{cardInfo.date}</h5>
          <p className="experience-card-location">{cardInfo.desc}</p>
        </div>
      </div>
      <div className="experience-card-body">
        <ul>
          <GetDescBullets descBullets={cardInfo.descBullets} />
        </ul>
      </div>
    </div>
  );
}